import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth.js";

// Página fora do grupo de permissões do usuário (D-27). Diz o porquê e quem
// resolve, em vez de devolver para o Início sem explicação.
export function SemAcesso() {
  const { user } = useAuth();
  return (
    <div className="mx-auto max-w-lg py-16 text-center" data-testid="sem-acesso">
      <div className="mb-3 text-4xl" aria-hidden="true">🔒</div>
      <h1 className="text-2xl font-semibold text-brand-950">Sem acesso a esta página</h1>
      <p className="mt-3 text-sm leading-relaxed text-slate-600">
        {user?.groupName ? <>Seu grupo é <b>{user.groupName}</b>. </> : null}
        Se você precisa desta tela, peça a alguém com acesso total para ajustar suas permissões.
      </p>
      <Link to="/" className="btn-primary mt-6 inline-flex">Voltar ao início</Link>
    </div>
  );
}
